import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { ServiceGrid } from '../components/ServiceGrid';
import { Extras } from '../components/Extras';
import { About } from '../components/About';
import { ServiceAreas } from '../components/ServiceAreas';
import { Reviews } from '../components/Reviews';
import { Gallery } from '../components/Gallery';
import { FAQ } from '../components/FAQ';
import { SeoContent } from '../components/SeoContent';
import { ContactForm } from '../components/ContactForm';
import { Contact } from '../components/Contact';
import { homeFaqs } from '../data/faqs';
import { businessEntity, websiteEntity, injectJsonLd, setHeadMeta, BUSINESS_ID, WEBSITE_ID, SITE_URL } from '../utils/seo';
export function HomePage() {
  // Handle initial hash in URL on page load and SEO meta tags
  useEffect(() => {
    setHeadMeta({
      title: "Mike's Pro Detail | Mobile Car Detailing in Ventura County",
      description: "Mike's Pro Detail provides professional mobile car detailing throughout Ventura County and select surrounding areas. We come to you for convenient interior, exterior and full car detailing. Call (818) 381-9905.",
      path: '/'
    });
    // Structured data: one linked @graph describing the business, the website,
    // the homepage itself, and the FAQ content that is visible on this page.
    const cleanup = injectJsonLd([businessEntity, websiteEntity, {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/#webpage`,
      url: `${SITE_URL}/`,
      name: "Mike's Pro Detail | Mobile Car Detailing in Ventura County",
      isPartOf: {
        '@id': WEBSITE_ID
      },
      about: {
        '@id': BUSINESS_ID
      },
      primaryImageOfPage: {
        '@id': BUSINESS_ID
      }
    }, {
      '@type': 'FAQPage',
      '@id': `${SITE_URL}/#faq`,
      isPartOf: {
        '@id': WEBSITE_ID
      },
      // Mirrors the visible FAQ accordion exactly (same source array).
      mainEntity: homeFaqs.map(f => ({
        '@type': 'Question',
        name: f.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: f.answer
        }
      }))
    }]);
    const hash = window.location.hash.slice(1);
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          const navHeight = 64;
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - navHeight;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
    return cleanup;
  }, []);
  return <main className="min-h-screen w-full bg-black text-white selection:bg-red-600 selection:text-white scroll-smooth" data-id="element-962" data-mp="1pzaps1wh6h7z">
      <Navigation data-id="element-963" data-mp="1kzoehy07jb1t" />
      <Hero data-id="element-964" data-mp="1l07uvaa7lrdq" />
      <Services data-id="element-965" data-mp="1l0he8f0r10ag" />
      <Extras data-id="element-966" data-mp="1kywpx7512dl1" />
      <ServiceGrid data-id="element-967" data-mp="iynxphgutvc" />
      <About data-id="element-968" data-mp="if423899veo" />
      <ServiceAreas data-id="element-969" data-mp="hx1ypywwmyu" />
      <SeoContent data-id="element-970" data-mp="hdvq6imjn0n" />
      <Reviews data-id="element-971" data-mp="gvokeufbody" />
      <Gallery data-id="element-972" data-mp="595dbrjsyien" />
      <FAQ data-id="element-973" data-mp="59ou34xpv0r3" />
      <ContactForm data-id="element-974" data-mp="5agoicfkusfs" />
      <Contact data-id="element-975" data-mp="5b00lcijqmlw" />
    </main>;
}